<template>
	<div class="v-application">
		<headerNav @handleBrage="handleBrage"></headerNav>
		<div class="v-application-wrapper">
			<div class="v-application-container">
				<sideBar ref="sideBarRef" :menuUrl="'order-lists'"></sideBar>
				<div class="v-content-white-wrapper">
					<div class="table-container">
						<div class="card-header">
							<h1 class="fs-20">{{$t('order.orders')}}</h1>
						</div>
						<!--						<div class="search-container">
							<div class="search-block">
								<el-input :placeholder="$t('product.query.name')" clearable></el-input>
							</div>
							<div class="search-btns" style="margin-top: 5px;">
								<el-button type="primary" size="small">
									{{ $t('button.search') }}
								</el-button>
								<el-button  size="small">{{ $t('button.reset') }}
								</el-button>
							</div>
						</div>-->


						<div class="table-wrap" style="margin: 10px 0;">
							<el-table :data="orderList" style="width: 100%" v-loading="tableLoading" :empty-text="$t('empty.nodata')">
								<el-table-column type="index" width="50"></el-table-column>
								<el-table-column prop="orderNo" :label="$t('order.ordercode')" min-width="250"></el-table-column>
								<el-table-column prop="totalProduct" :label="$t('order.numofproduct')" width="160">
								</el-table-column>
								<el-table-column prop="memberName" :label="$t('order.customer')" width="190"></el-table-column>
								<el-table-column prop="totalPrice" :label="$t('table.amount')" width="150">
									<template v-slot="scope">
										${{ scope.row.totalPrice }}
									</template>
								</el-table-column>
								<el-table-column prop="totalProfit" :label="$t('order.profit')" width="150">
									<template v-slot="scope">
										${{ scope.row.totalProfit }}
									</template>
								</el-table-column>

								<el-table-column prop="name" :label="$t('order.pickupstatus')" width="200">
									<template v-slot="scope">
										<el-tag effect="dark" color="#409eff" style="border-color:#EB5271;" v-show="scope.row.procurementStatus == 1">{{ scope.row.procurementStatusName }}</el-tag>
										<el-tag effect="dark" color="#EB5271" style="border-color:#409eff;" v-show="scope.row.procurementStatus != 1">{{ scope.row.procurementStatusName }}</el-tag>
										<!-- <el-tag effect="dark" color="#e2ac4c" style="border-color:#e2ac4c;" v-show="scope.row.procurementStatus == 2">{{ scope.row.procurementStatusName }}</el-tag>
										<el-tag effect="dark" color="#909399" style="border-color:#909399;" v-show="scope.row.procurementStatus == 3">{{ scope.row.procurementStatusName }}</el-tag>
										<el-tag effect="dark" color="#5cbf27" style="border-color:#5cbf27;" v-show="scope.row.procurementStatus == 4">{{ scope.row.procurementStatusName }}</el-tag>
										<el-tag effect="dark" color="#F4EB4A" style="border-color:#F4EB4A;" v-show="scope.row.procurementStatus == 5">{{ scope.row.procurementStatusName }}</el-tag>
										<el-tag effect="dark" color="#9f26af" style="border-color:#9f26af;" v-show="scope.row.procurementStatus == 6">{{ scope.row.procurementStatusName }}</el-tag> -->
									</template>
								</el-table-column>
								<el-table-column prop="name" :label="$t('table.status')" width="180">
									<template v-slot="scope">
										{{ getStatusLabel(scope.row.status) }}
									</template>
								</el-table-column>


								<el-table-column prop="name" :label="$t('table.paymentstatus')" width="200">
									<template v-slot="scope">
										<el-tag effect="dark" color="#10B16E" style="border-color:#10B16E;background:#10B16E" v-show="scope.row.status != 3" >{{ scope.row.payStaName }}</el-tag>
                    <el-tag effect="dark" color="#10B16E" style="border-color:#EB5271;background:#EB5271" v-show="scope.row.status == 3">{{ scope.row.payStaName }}</el-tag>
									</template>
								</el-table-column>
								<el-table-column :label="$t('table.options')" width="130">
									<template slot-scope="scope">
										<el-button type="primary" icon="el-icon-view" size="mini" circle plain @click="openPage('order-infos/?orderNo='+scope.row.orderNo)"></el-button>
									</template>
								</el-table-column>
							</el-table>
						</div>
						<template v-if="orderList.length > 0">
							<div class="table-mobile-wrapper">
								<div class="order-item-wrapper" v-for="item in orderList" @click="openPage('order-infos?orderNo='+item.orderNo)">
									<div class="order-item-header">
										<div class="order-no"># {{ item.orderNo }}</div>
										<span class="o-sta-txt">

											<el-tag type="primary" v-show="item.procurementStatus != 1">{{ item.procurementStatusName }}</el-tag>
											<el-tag effect="dark" color="#EB5271" style="border-color:#EB5271;" v-show="item.procurementStatus == 1">{{ item.procurementStatusName }}</el-tag>
										</span>
									</div>
									<div class="order-item-inner">
										<div class="order-item-label">
											<div class="o-item-label">{{$t('order.numofproduct')}}:</div>
											<div class="o-item-value"> {{ item.totalProduct }}</div>
										</div>
										<div class="order-item-label">
											<div class="o-item-label">{{$t('order.customer')}}:</div>
											<div class="o-item-value">{{ item.memberName }}</div>
										</div>
										<div class="order-item-label">
											<div class="o-item-label">{{$t('table.amount')}}:</div>
											<div class="o-item-value o-price">{{ item.totalPrice }}</div>
										</div>
										<div class="order-item-label">
											<div class="o-item-label">{{$t('order.profit')}}:</div>
											<div class="o-item-value o-price">${{ item.totalProfit }}</div>
										</div>

										<div class="order-item-label">
											<div class="o-item-label">{{$t('table.status')}}:</div>
											<div class="o-item-value">
												<el-tag :type="getStatusType(item.status)" disable-transitions>
													{{ getStatusLabel(item.status) }}
												</el-tag>

											</div>
										</div>
									</div>
								</div>
							</div>

							<!-- 分页组件 -->
							<div class="page-contrainer d-flex">
								<el-pagination background :page-count="isMobile ? 4 : 10" layout="prev, pager, next" :total="total"
									:current-page="pageNo" :page-sizes="[10, 20, 30, 50]" :page-size="pageSize"
									@current-change="handleCurrentChange" @size-change="handleSizeChange"
									@prev-click="handlePrevClick" @next-click="handleNextClick"></el-pagination>
							</div>
						</template>
						<template v-else>
							<div class="table-mobile-wrapper">
								<empty></empty>
							</div>
						</template>


					</div>
				</div>
			</div>
		</div>
		<tabBar ref="tabBarRef" current="2"></tabBar>
	</div>
</template>

<script>
	import headerNav from '../../components/headerNativation.vue'
	import sideBar from '../../components/sideBar.vue'
	import tabBar from '../../components/tabBar.vue'
	import empty from '../../components/empty.vue'
	import {
		orderList
	} from "@/api/order";
	export default {
		components: {
			headerNav,
			sideBar,
			tabBar,
			empty
		},
		dicts: ['order_status'],
		data() {
			return {
				tableLoading: false,
				orderList: [],
				total: 1,
				pageNo: 1,
				pageSize: 10,
				orderParams: {
					pageNum: 1,
					pageSize: 10,
				},
				isMobile:false
			}
		},
		created() {
			this.isMobile = this.webIsMobile()
			this.getOrderList();
		},
		methods: {
			handleBrage(){
				this.$refs.sideBarRef.handleBrage()
				this.$refs.tabBarRef.handleBrage()
			},
			handleSizeChange(newPageSize) {
				this.pageSize = newPageSize;
				this.pageNo = 1; // 切换每页数量时重置为第一页
				this.getOrderList();
			},
			getStatusType(status) {
				const statusMap = {
					'3': 'warning', // Unpaid
					'4': 'info', // shipping
					'5': 'danger', // Cancelled
					'6': 'success', // confirmed
					'7': 'success', // Paid
					'8': 'warning', // Refunding
					'9': 'info', // Refunded
					'1': 'success', // finished
					'2': 'warning' // Pending
				};
				return statusMap[status] || 'info';
			},
			getStatusLabel(status) {
				const labelMap = {
					'3': this.$t('button.cancel'),
					'4': this.$t('order.shipping'),
					'5': this.$t('table.cancelled'),
					'6': this.$t('table.confirmed'),
					'7': this.$t('table.paid'),
					'8': this.$t('table.refunding'),
					'9': this.$t('table.refunded'),
					'1': this.$t('table.finished'),
					'2': this.$t('table.pending')
				};
				return labelMap[status] || 'Unknown';
			},
			handleCurrentChange(currentPage) {
				this.pageNo = currentPage;
				this.getOrderList();
			},
			handlePrevClick(currentPage) {
				this.pageNo = currentPage;
				this.getOrderList();
			},
			handleNextClick(currentPage) {
				this.pageNo = currentPage;
				this.getOrderList();
			},
			getOrderList() {
				this.orderParams.pageNum = this.pageNo;
				this.orderParams.pageSize = this.pageSize;

				orderList(this.orderParams).then(res => {
					if (res.code == 200) {
						this.orderList = res.rows;
						this.total = res.total;
					} else {
						return false;
					}
				})
			},
		}
	}
</script>

<style scoped>
	@import url("../../assets/css/order.css");
</style>
